import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router';
import api from 'src/services/api';
import GoalGroupsForm from './GoalGroupsForm';
import GoalGroupsTable from './GoalGroupsTable';
import GoalGroupsToolbar from './GoalGroupsToolbar';

function GoalGroupsTab() {
  return (
    <Routes>
      <Route index element={<GoalGroupsList />} />
      <Route path="new" element={<GoalGroupsForm />} />
      <Route path="edit/:id" element={<GoalGroupsEditForm />} />
    </Routes>
  );
}

function GoalGroupsList() {
  return (
    <>
      <GoalGroupsToolbar />
      <GoalGroupsTable />
    </>
  );
}

function GoalGroupsEditForm() {
  const params = useParams();
  const {
    data: goalGroup,
    isLoading,
    refetch,
  } = useQuery(['goal-groups', params.id], async () => {
    if (!params.id) {
      return null;
    }

    return api.carePlan.getGoalGroup(params.id);
  });

  useEffect(() => {
    refetch();
  }, []);

  if (!goalGroup && !isLoading) return <Navigate to=".." />;
  return <GoalGroupsForm isEdit currentGoalGroup={goalGroup} />;
}

export default Object.assign(GoalGroupsTab, {
  path: 'goal-groups',
});
